import { useNotificationIntegration } from '@/hooks/useNotificationIntegration'

export const useMaxNotificationBotIntegration = (
  userId: string | number | null | undefined,
  userRole: string | null | undefined,
) => {
  const result = useNotificationIntegration('max', userId, userRole)

  return {
    status: result.status,
    integrationId: result.integrationId,
    displayHandle: result.displayHandle,
    necessarily: result.necessarily,
  }
}
